/**
 * Edit component
 */
import { __ } from '@wordpress/i18n';
import { useBlockProps } from '@wordpress/block-editor';

export default function Edit() {
	const blockProps = useBlockProps( {
		className: 'nemtly-event-price',
	} );

	return (
		<div { ...blockProps }>
			<span className="nemtly-price-preview">
				{ __( '$50.00', 'nemtly-booking' ) }
			</span>
		</div>
	);
}
